<template>
    <div class="proPage">
        <template v-if="generalStatus === null && userIsPro">
            <div class="status check" v-if="isDesktop">
              <div class="logo-tagline">
                <div class="logo">
                  <img src="/main/img/buddy-pro/buddy-pro-logo.svg" alt="">
                </div>
              </div>
              <div class="box">
                <div class="thankyou" :style="{'background-image': `url(/main/img/buddy-pro/buddy-thankyou.png)`}"></div>
              </div>
              <div class="box">
                <div class="note">
                  <div class="top">
                    <span>{{ trans('payment.active_until') }}</span>
                  </div>
                  <div class="bottom">
                    <div class="title">{{ proExpireDate }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="secondary-menu status check" v-if="isMobile">
                <div class="secondary-menu-body">
                    <div class="logo-tagline">
                        <div class="logo">
                            <img src="/main/img/buddy-pro/buddy-pro-logo.svg" alt="">
                        </div>
                    </div>
                    <div class="box">
                        <div class="thankyou" :style="{'background-image': `url(/main/img/buddy-pro/buddy-thankyou.png)`}"></div>
                    </div>
                    <div class="box">
                        <div class="note">
                            <div class="top">
                                <span>{{ trans('payment.active_until') }}</span>
                            </div>
                            <div class="bottom">
                                <div class="title">{{ proExpireDate }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <template v-else-if="generalStatus === 'success'">
            <div class="status success" v-if="isDesktop">
                <div class="logo-tagline">
                    <div class="logo">
                        <img src="/main/img/buddy-pro/buddy-pro-logo.svg" alt="">
                    </div>
                </div>
                <div class="box">
                    <div class="thankyou" :style="{'background-image': `url(/main/img/buddy-pro/buddy-thankyou.png)`}"></div>
                </div>
                <div class="box">
                    <div class="note">
                        <div class="top"></div>
                        <div class="bottom">
                            <div class="title">{{ userIsPro ? trans('successful_pro_upgrade') : trans('we_hope_you_enjoyed_pro') }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="secondary-menu status success" v-if="isMobile">
                <div class="secondary-menu-body">
                    <div class="logo-tagline">
                        <div class="logo">
                            <img src="/main/img/buddy-pro/buddy-pro-logo.svg" alt="">
                        </div>
                    </div>
                    <div class="box">
                        <div class="thankyou" :style="{'background-image': `url(/main/img/buddy-pro/buddy-thankyou.png)`}"></div>
                    </div>
                    <div class="box">
                        <div class="note">
                            <div class="top"></div>
                            <div class="bottom">
                                <div class="title">{{ userIsPro ? trans('successful_pro_upgrade') : trans('we_hope_you_enjoyed_pro') }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <template v-else-if="generalStatus === 'error'">
            <div class="status error" v-if="isDesktop">
                <div class="logo-tagline">
                    <div class="logo">
                        <img src="/main/img/buddy-pro/buddy-pro-logo.svg" alt="">
                    </div>
                </div>
                <div class="box">
                    <div class="thankyou" :style="{'background-image': `url(/images/splash/avatar_sorry.png)`}"></div>
                </div>
                <div class="box">
                    <div class="note">
                        <div class="top"></div>
                        <div class="bottom">
                            <div class="title failed">{{ trans('failed_pro_upgrade') }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="secondary-menu status error" v-if="isMobile">
                <div class="secondary-menu-body">
                    <div class="logo-tagline">
                        <div class="logo">
                            <img src="/main/img/buddy-pro/buddy-pro-logo.svg" alt="">
                        </div>
                    </div>
                    <div class="box">
                        <div class="thankyou" :style="{'background-image': `url(/images/splash/avatar_sorry.png)`}"></div>
                    </div>
                    <div class="box">
                        <div class="note">
                            <div class="top"></div>
                            <div class="bottom">
                                <div class="title failed">{{ trans('failed_pro_upgrade') }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import {mapActions, mapMutations, mapState} from 'vuex';

    export default {
        props: ['code'],
        mixins: [
            require('@general/lib/mixin').default
        ],
        data() {
            return {
                generalStatus: null,
            }
        },
        components: {
        },
        computed: {
            ...mapState({
                userIsPro: 'userIsPro',
                profile: 'profile',
            }),
            proExpireDate() {
                return moment(this.profile.pro_expires_at).format('D MMMM YYYY')
            },
            origin() {
                return `https://${window.APP_DOMAIN}`;
            },
        },
        methods: {
            ...mapMutations([
                'setUserIsPro',
                'setDiscreetMode',
            ]),
            ...mapActions([
                'loadCurrentUserInfo',
            ]),
            setStatus(status) {
                this.generalStatus = status
                if (status === 'error') {
                    this.$emit('bottomMenuState', true)
                }
            },
            async submitPromoCode(code) {
                try {
                    let response = await axios.post('/api/subscription/promocode', {
                        code
                    })
                    if (response.status === 200) {
                        let data = response.data
                        this.setUserIsPro(true)
                        this.setDiscreetMode(data.discreetMode)
                        this.loadCurrentUserInfo(true)
                        this.$emit('bottomMenuState', true)
                        this.setStatus('success')
                    } else {
                        this.setStatus('error')
                    }
                } catch (e) {
                    this.setStatus('error')
                }
            },
        },
        async created() {
            if (!!this.code) {
                if (!this.userIsPro) {
                    await this.submitPromoCode(this.code)
                }
            } else {
                this.setStatus('error')
            }
        }
    }
</script>
